export const DOT_CMS_SUB_CONTENTLET_KEYS = [
  'banners',
  'images',
  'videos',
  'faq',
  'blogComment',
  'author',
  'reply',
  'commentAuthor',
  'blogContent',
  'productsTooltip',
  'blogs',
  'categoryCard',
  //TODO for Rich text and faq widget
  // 'body',
  // 'answer',
];
